import React from 'react'

import {
  canAddAnotherSurface,
  ProcedureSurfaceSelectionRules,
} from '@utils/procedure-surface-selection.utils'

type ToothSurfaceRowProps = {
  toothNum: number
  selectedSurfaces: string[]
  availableSurfaces: string[]
  requiresSurfaceSelection: boolean
  surfaceRules: ProcedureSurfaceSelectionRules
  onSurfaceToggle: (toothNum: number, surface: string) => void
  onRemove: (toothNum: number) => void
}

const ToothSurfaceRow: React.FC<ToothSurfaceRowProps> = ({
  toothNum,
  selectedSurfaces,
  availableSurfaces,
  requiresSurfaceSelection,
  surfaceRules,
  onSurfaceToggle,
  onRemove,
}) => {
  return (
    <div className="appt-tooth-surface-row">
      <span className="appt-tooth-surface-row-label">{toothNum}</span>
      {requiresSurfaceSelection && (
        <div className="appt-tooth-surface-row-chips">
          {availableSurfaces.map((surface) => {
            const isSelected = selectedSurfaces.includes(surface)
            const isDisabled =
              !isSelected &&
              !canAddAnotherSurface(
                selectedSurfaces.length,
                surfaceRules.surfaceCount,
                surfaceRules.surfaceCountIsMin,
              )
            return (
              <button
                type="button"
                key={surface}
                className={`unstyled-button appt-tooth-surface-chip ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                aria-pressed={isSelected}
                aria-disabled={isDisabled}
                disabled={isDisabled && !isSelected}
                onClick={() => {
                  if (!isDisabled || isSelected) {
                    onSurfaceToggle(toothNum, surface)
                  }
                }}
              >
                {surface}
              </button>
            )
          })}
        </div>
      )}
      <button
        type="button"
        className="unstyled-button appt-tooth-surface-row-remove"
        aria-label={`Remove tooth ${toothNum}`}
        onClick={() => onRemove(toothNum)}
      >
        <i className="tag-item-close ti ti-x" />
      </button>
    </div>
  )
}

export default ToothSurfaceRow
